import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams,useLocation } from 'react-router-dom';
import DashboardLayout from './components/layout/Dashboardlayout';
import { Card, CardContent, CardHeader, CardTitle } from './components/ui/Card';
import { Loader2, FileText, Trash2,Instagram } from 'lucide-react';
import { Button } from './components/ui/button';
import { supabase } from './integrations/supabase/client';
import { format } from 'date-fns';
import axios from 'axios';

const ContentPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const businessId = searchParams.get('business');
  const [demoKey, setDemoKey] = useState("");
  const location = useLocation();
  const [business, setBusiness] = useState([]);
  
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const sessionId = location.state?.sessionId || localStorage.getItem('session_id');
  
  const [user, setUser] = useState(null);
  const [postingId, setPostingId] = useState(null);
  const [generating, setGenerating] = useState(false);
  const loadUser = async () => {
  try {
    if (!sessionId) return null;

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/user`, {
        params: { sessionId },
    });

    setUser(res.data);
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

  const handleGenerate = async () => {
  try {
    setGenerating(true);
    const u = await loadUser();
    await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/videos/generate`,
      {
        owner_id: u?.userId,
        business_id: businessId,
      },
      {
        headers: {
          'x-api-key': demoKey,
        },
      }
    );
  await fetchContents(u?.userId);

  } catch (err) {
    console.error('Generate error:', err);
  } finally {
    setGenerating(false);
  }
};

  const fetchBusiness = async (ownerId) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/businessesid`,
      {
        params: {
          owner_id: ownerId,
          business_id: businessId,
        },
      }
    );
    setBusiness(res.data);
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};


  const fetchContents = async (ownerId) => {
  if (!ownerId) return;
  const owner_id= ownerId;

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/videos/${owner_id}`
    );
    setContents(res.data || []);
  } catch (err) {
    console.error(err);
  }
};


  const handlePostInstagram = async (videoId) => {
      setPostingId(videoId);
      try {
        await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/videos/post-instagram/${videoId}/${user.id}`
        );
        await fetchContents();
      } catch (e) {
      } finally {
        setPostingId(null);
      }
    };


  const updateContentStatus = async (contentId, status) => {
    await supabase
      .from('generated_content')
      .update({ status })
      .eq('id', contentId);

    setContents((prev) =>
      prev.map((c) => (c.id === contentId ? { ...c, status } : c))
    );
  };

  const deleteContent = async (contentId) => {
    await supabase
      .from('generated_content')
      .delete()
      .eq('id', contentId);

    setContents((prev) => prev.filter((c) => c.id !== contentId));
  };


useEffect(() => {
  const load = async () => {
    setLoading(true);

    try {
      const u = await loadUser();
      if (!u) return;

      const b = await fetchBusiness(u.userId);
      if (!b) return;

      await fetchContents(u.userId);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  load();
}, [businessId]);



  return (
    <DashboardLayout>
      <div className="space-y-8 pt-32">
        <div>
  <h1 className="text-3xl font-bold">Create Content</h1>
  <p className="text-muted-foreground">
    Generate viral marketing content with AI
  </p>


  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
  <label
    style={{
      fontSize: '14px',
      fontWeight: '500'
    }}
  >
    Demo Key
  </label>

  <input
    type="text"
    value={demoKey}
    onChange={(e) => setDemoKey(e.target.value)}
    style={{
      width: '100%',
      padding: '10px 16px',
      borderRadius: '8px',
      border: '1px solid #e5e7eb',
      fontSize: '14px',
      background: '#ffffff',
      outline: 'none',
      transition: 'border-color 0.2s'
    }}
    placeholder="Enter your demo key"
  />
</div>

  <div className="mt-4">
    <Button onClick={handleGenerate} disabled={generating}>
      {generating ? (
        <>
          <Loader2 className="w-4 h-4 mr-2 animate-spin" />
          Generating...
        </>
      ) : (
        "Generate Video"
      )}
    </Button>
  </div>
</div>


        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <FileText className="w-5 h-5" />
              Content History
            </CardTitle>
          </CardHeader>

          <CardContent>
            {contents.length ? (
              <div className="space-y-4">
                {contents.map((content) => (
                  <div
                    key={content.id}
                    className="p-4 border rounded-lg hover:border-primary/30 transition"
                  >
                    <div className="flex justify-between gap-4">
                      <div>
                        <h3 className="font-semibold">
                          {content.caption || 'Untitled'}
                        </h3>
                        <p className="text-sm text-muted-foreground line-clamp-2">
                          {content.script || 'No content'}
                        </p>
                        <div className="text-xs text-muted-foreground mt-1">
                          {format(
                            new Date(content.created_at),
                            'MMM d, yyyy'
                          )}
                        </div>
                        <div className="w-full aspect-[9/16] bg-black">
    <video
        key={content.id}  // ← force re-render
        controls
        style={{width: '100%', height: '100%'}}
        crossOrigin="anonymous"
        preload="metadata"
        onCanPlay={() => console.log(content.video_url)}
    >
        <source src={content.video_url}  />
        Your browser does not support the video tag.
    </video>
</div>
                      </div>
                      <div className="flex gap-2 pt-1">
                                                {/* Download */}
                                                <a
                                                  href={content.video_url}
                                                  download
                                                  target="_blank"
                                                  rel="noreferrer"
                                                  className="flex-1"
                                                >
                                                  <Button size="sm" variant="outline" className="w-full text-xs" onClick={() => window.open(content.video_url, '_blank')}>
                                                    Download
                                                  </Button>
                                                </a>
                      </div>
                      <div className="flex gap-2">
                        {content.status === 'ready' && (
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() =>
                              updateContentStatus(content.id, 'published')
                            }
                          >
                            Publish
                          </Button>
                        )}
                        <Button
                          size="icon"
                          variant="ghost"
                          onClick={() => deleteContent(content.id)}
                        >
                          <Trash2 className="w-4 h-4 text-destructive" />
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-8 text-muted-foreground">
                <FileText className="w-12 h-12 mx-auto mb-3 opacity-50" />
                <p>No content generated yet</p>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default ContentPage;
